import { errorToast } from "@/v2-ui/toast"
import {
  type ConfirmButtonProps,
  ConfirmButton,
} from "@/v2-backoffice-client/components/button"
import { useTenantRemoveManyMutation } from "@/v2-backoffice-client/tenant/remove/many/tenant.remove.many.mutation"

export type TenantRemoveManyButtonProps = Omit<
  ConfirmButtonProps,
  "onConfirm"
> & {
  tenantIds: number[]
  onCompleted?(): void
}

function TenantRemoveManyButton(props: TenantRemoveManyButtonProps) {
  const { tenantIds, confirmContent, onCompleted, ...confirmButtonProps } =
    props
  const tenantCount = tenantIds.length

  const [removeManyTenants, { loading, error }] = useTenantRemoveManyMutation({
    onCompleted,
  })

  errorToast(error, {
    title: `Failed to remove ${tenantCount} team(s)`,
  })

  return (
    <ConfirmButton
      id="tenant-remove-many-button"
      variant="destructive"
      size="tiny"
      iconSrc="trash"
      content="Remove teams"
      confirmContent={
        confirmContent ??
        `Are you sure you want to remove ${tenantCount} team(s)?`
      }
      isLoading={loading}
      onConfirm={() => {
        removeManyTenants({ variables: { ids: tenantIds } })
      }}
      {...confirmButtonProps}
    />
  )
}

export default TenantRemoveManyButton
